import { getAuthToken } from "@/utils/authUtils";
import type { UserRatingRecord } from "@/utils/userRatingStorage";

// POST /api/v1/embarca-log/ratings
//
// O Bearer é opcional: com token o backend vincula o feedback ao customer_id,
// sem token grava anônimo. O corpo é o mesmo objeto guardado no localStorage
// (`timestamp` em epoch ms vira `rated_at` no backend).
export const sendUserRating = async (
  record: UserRatingRecord
): Promise<void> => {
  const token = getAuthToken();

  try {
    await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL_API}/api/v1/embarca-log/ratings`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        // A barra some logo depois do envio (e o usuário pode fechar a aba):
        // keepalive mantém o request vivo além do unload.
        keepalive: true,
        body: JSON.stringify({
          status: record.status,
          score: record.score,
          comment: record.comment,
          timestamp: record.timestamp,
        }),
      }
    );
  } catch {
    // Feedback é best-effort: falha de rede não trava o fluxo nem avisa o usuário.
  }
};
